<template>
    <div class="container">
        <nav class="navbar navbar-expand navbar-light bg-light">
         <router-link to="/" class="text-dark mr-4">
            <h2><i class="fas fa-monument"></i> &nbsp;MGA Monuments</h2>
        </router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavAltMarkup" aria-controls="navbarNavAltMarkup" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav mr-auto">
                    <!--<router-link to="/" class="nav-link">Home</router-link>
                        <router-link :to="{name: 'Orders'}"><a class="nav-link text-success">Orders</a></router-link>-->                                                                                                       
                </div>
                    <span class="lead text-success" v-if="getCurrentUser.username">Hi {{getCurrentUser.username}}, &nbsp;
                        <router-link :to="{name: 'Admin'}">Office</router-link> &nbsp;&nbsp;                       
                        <a class="lead text-danger" href="#" @click="logout">Logout</a>
                    </span>
                    <span v-else>
                        <router-link :to="{name: 'Admin'}" class="nav-link text-secondary"><i class="fas fa-sign-in-alt"></i> Orders</router-link>
                    </span>
            </div>
        </nav> 
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {mapActions} from 'vuex'
    export default {
        computed: {
            ...mapGetters(['getCurrentUser', 'getUserStatus'])            
        },
        methods: {
            ...mapActions(['updateUser']),
            logout() {
                var ok = confirm("Going home?")
                if(ok){
                   localStorage.removeItem("id");
                   localStorage.removeItem("security")
                   this.$store.state.isAuthenticated = false                   
                }
                this.destroyUser()
                console.log('You are logged out!')
            },
            destroyUser(){
                this.updateUser('')
                console.log('User destroyed!')
                this.$router.push({name: 'Home'})
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Helpers/Header.vue